module.exports = __webpack_public_path__ + "assets/e8b79c0b78f7ee053bf552c4dd496f56.png";